@if (chartConfig$ | async; as chartConfig) {
  <div class="mb-2">
    @if (chartConfig.data.length && chartConfig.data.length !== 0) {
      <app-websites-apps-by-risk-management-chart [config]="chartConfig"></app-websites-apps-by-risk-management-chart>
    } @else {
      @if (emptyStateConfig$ | async; as emptyStateConfig) {
        <table-empty-state [config]="emptyStateConfig"></table-empty-state>
      }
    }
  </div>
}
